module.exports = __webpack_public_path__ + "img/education-careers.e2ee7603.jpg";